var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleRedSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_65",
    "data-name": "Ellisse 65",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#e03625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRedSelected);
export default __webpack_public_path__ + "static/media/circle-red-selected.2364db896b6e815e8ddddb676b8f2b81.svg";
export { ForwardRef as ReactComponent };